"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelStatus = exports.ModelType = exports.Algorithm = exports.Goal = exports.TrainingPhase = exports.SubspaceType = void 0;
var SubspaceType;
(function (SubspaceType) {
    SubspaceType[SubspaceType["Connect"] = 0] = "Connect";
    SubspaceType[SubspaceType["Define"] = 1] = "Define";
    SubspaceType[SubspaceType["Train"] = 2] = "Train";
    SubspaceType[SubspaceType["Results"] = 3] = "Results";
    SubspaceType[SubspaceType["Deploy"] = 4] = "Deploy";
})(SubspaceType = exports.SubspaceType || (exports.SubspaceType = {}));
var TrainingPhase;
(function (TrainingPhase) {
    TrainingPhase[TrainingPhase["Undefined"] = 0] = "Undefined";
    TrainingPhase[TrainingPhase["Processing"] = 1] = "Processing";
    TrainingPhase[TrainingPhase["DataMovement"] = 2] = "DataMovement";
    TrainingPhase[TrainingPhase["DescriptiveAnalysis"] = 3] = "DescriptiveAnalysis";
    TrainingPhase[TrainingPhase["ModelCreation"] = 4] = "ModelCreation";
    TrainingPhase[TrainingPhase["Complete"] = 5] = "Complete";
})(TrainingPhase = exports.TrainingPhase || (exports.TrainingPhase = {}));
var Goal;
(function (Goal) {
    Goal["Maximize"] = "Maximize";
    Goal["Minimize"] = "Minimize";
})(Goal = exports.Goal || (exports.Goal = {}));
var Algorithm;
(function (Algorithm) {
    Algorithm["GLM"] = "GLM";
    Algorithm["GBM"] = "GBM";
    Algorithm["XGBoost"] = "XGBoost";
    Algorithm["RandomForest"] = "RandomForest";
    Algorithm["Model_Tournament"] = "Model Tournament";
})(Algorithm = exports.Algorithm || (exports.Algorithm = {}));
var ModelType;
(function (ModelType) {
    ModelType[ModelType["Regression"] = 0] = "Regression";
    ModelType[ModelType["Binary"] = 1] = "Binary";
    ModelType[ModelType["Undefined"] = 2] = "Undefined";
})(ModelType = exports.ModelType || (exports.ModelType = {}));
var ModelStatus;
(function (ModelStatus) {
    ModelStatus[ModelStatus["Undefined"] = 0] = "Undefined";
    ModelStatus[ModelStatus["ObjectiveDefined"] = 1] = "ObjectiveDefined";
    ModelStatus[ModelStatus["Training"] = 2] = "Training";
    ModelStatus[ModelStatus["Trained"] = 3] = "Trained";
    ModelStatus[ModelStatus["Deployed"] = 4] = "Deployed";
})(ModelStatus = exports.ModelStatus || (exports.ModelStatus = {}));
//# sourceMappingURL=Utils.js.map